import styled from 'styled-components';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const Container = styled.div`
  width: 100%;
`;

export const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 16px;
  border: 1px solid ${({ theme }) => theme.colors?.border || 'rgba(0, 0, 0, 0.25)'};
  border-radius: 12px;
  background: white;
  cursor: pointer;
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors?.text || COLOR_CONFIG['neutral-text']};
  width: 100%;
  outline: none;

  &:hover {
    background: ${({ theme }) => theme.colors?.backgroundHover};
  }

  svg {
    color: ${({ theme }) => theme.colors?.icon};
  }

  /* &:focus {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    border-color: ${COLOR.primary['primary-6']};
  } */
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 3.5rem;
  left: 38px;
  z-index: 1000;
  min-width: 432px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`;

export const TabList = styled.nav`
  display: flex;
`;

export const Tab = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ active }) => (active ? COLOR.primary['primary-6'] : COLOR_CONFIG['neutral-text'])};
  border-bottom: 2px solid ${({ active }) => (active ? COLOR.primary['primary-6'] : '#d9d9d9')};
  font-weight: 600;
  line-height: 22px;
  font-size: 16px;

  &:hover {
    color: ${({ active }) =>
      active ? COLOR.primary['primary-6'] : COLOR.surfaceNeutralBold['neutral-11']};
  }
`;

export const InviteeList = styled.section`
  max-height: 240px;
  overflow-y: auto;
  scroll-behavior: smooth;
`;

export const InviteeItem = styled.article<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;

  cursor: pointer;
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.colors?.backgroundSelected : 'transparent'};

  &:hover {
    background: ${COLOR.neutral['neutral-4']};
  }
`;

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const InviteeInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const InviteeName = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  max-width: 315px;
  color: ${COLOR.surfaceNeutralBold['neutral-11']};
`;

export const InviteeType = styled.span`
  font-size: 12px;
  color: ${COLOR_CONFIG['neutral-text']};
  font-weight: 400;
  line-height: 16px;
  text-transform: capitalize;
`;

export const ScheduleOverlap = styled.span`
  display: flex;
  font-size: 12px;
  line-height: 16px;
  gap: 6px;
  color: ${COLOR_CONFIG.red};
`;

export const SelectedInvitees = styled.section`
  margin-top: 16px;
`;

export const GroupHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 12px 0 7px 36px;
  font-size: 14px;
  line-height: 20px;
  color: ${COLOR.surfaceNeutralBold['neutral-11']};

  span {
    color: ${({ theme }) => theme.colors?.text};
    font-weight: 500;
  }
`;

export const InviteeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
`;

export const AvatarContainer = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

export const StatusIcon = styled.div`
  position: absolute;
  bottom: -4px;
  right: 0;
`;
